import NavLinks from "./NavLinks";
import UserProfileDropdown from "./UserProfileDropdown";
// import AuthButtons from "./AuthButtons";
import { Button } from "@/components/ui/button";
import { PlusCircle } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { User } from "@/lib/types/userTypes"; // Import User type
import { useListingFormContext } from "@/context/ListingFormContext"; // Import useListingFormContext

interface MobileMenuProps {
  isMenuOpen: boolean;
  setIsMenuOpen: (isOpen: boolean) => void;
  user: User | null; // Updated user type
  handleLogout: () => void;
}

const MobileMenu = ({
  isMenuOpen,
  setIsMenuOpen,
  user,
  handleLogout,
}: MobileMenuProps) => {
  const navigate = useNavigate(); // Added useNavigate hook
  const { clearAllListingData } = useListingFormContext(); // Use the context

  const handlePostAdClick = () => {
    clearAllListingData(); // Clear local storage
    navigate("/dashboard/add-listing");
    setIsMenuOpen(false);
  };

  return (
    <div className={`md:hidden ${isMenuOpen ? "block" : "hidden"}`}>
      <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-white shadow-lg animate-fade-in">
        <NavLinks
          isMobile={true}
          onMobileItemClick={() => setIsMenuOpen(false)}
        />

        {user && ( // Only show Post Ad and Dashboard if user is authenticated
          <>
            <div className="px-1 py-2">
              <Button
                onClick={handlePostAdClick}
                variant="default"
                className="w-full bg-propertylk-blue hover:bg-propertylk-blue/90 text-white flex items-center justify-center"
              >
                <PlusCircle className="h-5 w-5 mr-2" />
                Post Ad
              </Button>
            </div>
          </>
        )}

        <div className="pt-4 pb-3 border-t border-gray-200">
          {user ? (
            <>
              <UserProfileDropdown
                user={user}
                handleLogout={handleLogout}
                setIsMenuOpen={setIsMenuOpen}
                isMobile={true}
              />
            </>
          ) : (
            <></>
          )}
        </div>
      </div>
    </div>
  );
};

export default MobileMenu;
